/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyCalendar,
  PharmacyCalendarFromJSON,
  PharmacyCalendarToJSON,
  PharmacyTemporaryCalendar,
  PharmacyTemporaryCalendarFromJSON,
  PharmacyTemporaryCalendarToJSON,
  PutPharmacyTemporaryCalendarRequestBody,
  PutPharmacyTemporaryCalendarRequestBodyFromJSON,
  PutPharmacyTemporaryCalendarRequestBodyToJSON,
} from "../models";

export interface DeletePharmacyCalendarRequest {
  pharmacyId: number;
  date: string;
}

export interface GetPharmacyCalendarRequest {
  pharmacyId: number;
  date: string;
  ignoreTemporary?: boolean;
  splitHours?: boolean;
}

export interface GetPharmacyCalendarsRequest {
  pharmacyId: number;
  from: string;
  to?: string;
}

export interface PutPharmacyTemporaryCalendarRequest {
  pharmacyId: number;
  date: string;
  putPharmacyTemporaryCalendarRequestBody: PutPharmacyTemporaryCalendarRequestBody;
}

/**
 *
 */
export class CalendarApi extends runtime.BaseAPI {
  /**
   * Delete Pharmacy calendar
   */
  async deletePharmacyCalendarRaw(
    requestParameters: DeletePharmacyCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling deletePharmacyCalendar."
      );
    }

    if (requestParameters.date === null || requestParameters.date === undefined) {
      throw new runtime.RequiredError(
        "date",
        "Required parameter requestParameters.date was null or undefined when calling deletePharmacyCalendar."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/temporary-calendars/{date}`
          .replace(`{${"pharmacy_id"}}`, encodeURIComponent(String(requestParameters.pharmacyId)))
          .replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete Pharmacy calendar
   */
  async deletePharmacyCalendar(
    requestParameters: DeletePharmacyCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    await this.deletePharmacyCalendarRaw(requestParameters, initOverrides);
  }

  /**
   * Get Pharmacy calendar by date
   */
  async getPharmacyCalendarRaw(
    requestParameters: GetPharmacyCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyCalendar>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getPharmacyCalendar."
      );
    }

    if (requestParameters.date === null || requestParameters.date === undefined) {
      throw new runtime.RequiredError(
        "date",
        "Required parameter requestParameters.date was null or undefined when calling getPharmacyCalendar."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.ignoreTemporary !== undefined) {
      queryParameters["ignore_temporary"] = requestParameters.ignoreTemporary;
    }

    if (requestParameters.splitHours !== undefined) {
      queryParameters["split_hours"] = requestParameters.splitHours;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/calendars/{date}`
          .replace(`{${"pharmacy_id"}}`, encodeURIComponent(String(requestParameters.pharmacyId)))
          .replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyCalendarFromJSON(jsonValue));
  }

  /**
   * Get Pharmacy calendar by date
   */
  async getPharmacyCalendar(
    requestParameters: GetPharmacyCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyCalendar> {
    return promiseRetry(
      (retry) =>
        this.getPharmacyCalendarRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Get Pharmacy calendars
   */
  async getPharmacyCalendarsRaw(
    requestParameters: GetPharmacyCalendarsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<Array<PharmacyCalendar>>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling getPharmacyCalendars."
      );
    }

    if (requestParameters.from === null || requestParameters.from === undefined) {
      throw new runtime.RequiredError(
        "from",
        "Required parameter requestParameters.from was null or undefined when calling getPharmacyCalendars."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.from !== undefined) {
      queryParameters["from"] = requestParameters.from;
    }

    if (requestParameters.to !== undefined) {
      queryParameters["to"] = requestParameters.to;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/calendars`.replace(
          `{${"pharmacy_id"}}`,
          encodeURIComponent(String(requestParameters.pharmacyId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PharmacyCalendarFromJSON));
  }

  /**
   * Get Pharmacy calendars
   */
  async getPharmacyCalendars(
    requestParameters: GetPharmacyCalendarsRequest,
    initOverrides?: RequestInit
  ): Promise<Array<PharmacyCalendar>> {
    return promiseRetry(
      (retry) =>
        this.getPharmacyCalendarsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Put Pharmacy temporary calendar
   */
  async putPharmacyTemporaryCalendarRaw(
    requestParameters: PutPharmacyTemporaryCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyTemporaryCalendar>> {
    if (requestParameters.pharmacyId === null || requestParameters.pharmacyId === undefined) {
      throw new runtime.RequiredError(
        "pharmacyId",
        "Required parameter requestParameters.pharmacyId was null or undefined when calling putPharmacyTemporaryCalendar."
      );
    }

    if (requestParameters.date === null || requestParameters.date === undefined) {
      throw new runtime.RequiredError(
        "date",
        "Required parameter requestParameters.date was null or undefined when calling putPharmacyTemporaryCalendar."
      );
    }

    if (
      requestParameters.putPharmacyTemporaryCalendarRequestBody === null ||
      requestParameters.putPharmacyTemporaryCalendarRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putPharmacyTemporaryCalendarRequestBody",
        "Required parameter requestParameters.putPharmacyTemporaryCalendarRequestBody was null or undefined when calling putPharmacyTemporaryCalendar."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/pharmacies/{pharmacy_id}/temporary-calendars/{date}`
          .replace(`{${"pharmacy_id"}}`, encodeURIComponent(String(requestParameters.pharmacyId)))
          .replace(`{${"date"}}`, encodeURIComponent(String(requestParameters.date))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutPharmacyTemporaryCalendarRequestBodyToJSON(requestParameters.putPharmacyTemporaryCalendarRequestBody),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyTemporaryCalendarFromJSON(jsonValue));
  }

  /**
   * Put Pharmacy temporary calendar
   */
  async putPharmacyTemporaryCalendar(
    requestParameters: PutPharmacyTemporaryCalendarRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyTemporaryCalendar> {
    return promiseRetry(
      (retry) =>
        this.putPharmacyTemporaryCalendarRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
